import React from 'react';
import { Facebook, Mail, MapPin, Phone } from 'lucide-react';
import { company } from '../data/company';
export function Footer() {
  return <footer className="border-t border-ink-line bg-ink text-white" data-id="element-26" data-mp="3ggk6ap6ov1ww">
      <div className="mx-auto max-w-6xl px-6 py-14" data-id="element-27" data-mp="32ovwwtntqrjm">
        <div className="flex flex-wrap items-start justify-between gap-10" data-id="element-28" data-mp="32m1c310wf4po">
          <div data-id="element-29" data-mp="36ppivhhphw9v">
            <img src={company.logo} alt={company.legalName} className="h-12 w-auto" data-id="element-30" data-mp="36n3cvmagrotr" />
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.18em] text-white/45" data-id="element-31" data-mp="38zbay6h7b62">
              {company.base} · {company.hours}
            </p>
          </div>

          <div className="flex flex-col gap-3 text-sm" data-id="element-32" data-mp="3qd6r5dz0lsyx">
            <a href={company.phoneHref} className="inline-flex items-center gap-2 text-white/85 hover:text-gold" data-id="element-33" data-mp="3qbvq3lwyezbi">
              <Phone className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-34" data-mp="2eyt94pqy07qt" />
              {company.phone}
            </a>
            <a href={`mailto:${company.email}`} className="inline-flex items-center gap-2 break-all text-white/85 hover:text-gold" data-id="element-35" data-mp="3lalfndz543tf">
              <Mail className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-36" data-mp="3v7gbtq7xxs4j" />
              {company.email}
            </a>
            <a href={company.google} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-white/85 hover:text-gold" data-id="element-37" data-mp="3q7lmhr3tdall">
              <MapPin className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-38" data-mp="33e6nbb9yssq" />
              Google Maps profile
            </a>
            <a href={company.facebook} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-white/85 hover:text-gold" data-id="element-39" data-mp="huwhkupa1x58">
              <Facebook className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-40" data-mp="mrwp7a1rz7yg" />
              Facebook
            </a>
          </div>
        </div>

        <p className="mt-12 border-t border-ink-line pt-6 font-mono text-[10px] uppercase tracking-[0.16em] text-white/40" data-id="element-41" data-mp="tw5yw7u65sn9">
          © {new Date().getFullYear()} {company.legalName} · Licensed &amp; insured
        </p>
      </div>
    </footer>;
}